import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';

const SingleFinancialForecastDetails = () => {
  const { forecastId } = useParams();
  const decodedId = forecastId ? atob(forecastId) : forecastId;
  const id = decodedId.replace(/\D/g, '');  // Ensure we only get the numeric part
  const [forecastDetails, setForecastDetails] = useState(null);

  const [columns, setColumnDetails] = useState([]);

  useEffect(() => {
    const fetchForecastDetails = async () => {
      try {
        const response = await axios.get(`${API_DOMAIN}${API_ROUTES.financial_forecast}${id}/`, { headers });
        const extractedColumns = Object.keys(response.data);

        // Define which columns to exclude (if necessary)
        const excludedColumns = ['id', 'created_at', 'updated_at'];
        const columnsArray = extractedColumns
          .filter((column) => !excludedColumns.includes(column))
          .map((column) => ({
            label: column.charAt(0).toUpperCase() + column.slice(1).replace('_', ' '),
            field: column,
          }));

        setColumnDetails(columnsArray);
        setForecastDetails(response.data);
      } catch (error) {
        console.error('Error fetching financial forecast details:', error);
      }
    };

    fetchForecastDetails();
  }, [forecastId]);

  return (
    <div>
      {forecastDetails ? (
        <SingleItemDetailTemplate details={forecastDetails} columns={columns} />
      ) : (
        <p>Loading financial forecast details...</p>
      )}
    </div>
  );
};

export default SingleFinancialForecastDetails;